// Standard library imports
import React, { useEffect, useState } from 'react';
// External library imports
import momentTz from 'moment-timezone';

// Internal module imports
import { momentTimeFormater, timeOnly } from '../../../utils/dateHelper';
import { useLoader } from '../../../hooks/use-loader.hook';
import { InstanceDataLogsService } from '../../../services/InstanceDataLogsService';
import { Capitalize } from '../../../utils/stringHelper';
import EChart from '../../../components/Echarts/Echarts';

// Css imports
import classes from '../Home.module.css';
import { usToEuCurrencyFormat } from '../../../utils/currencyHelper';

const InstanceCard = ({ groupId, licenseName }) => {
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [group, setGroup] = useState({});
    const [lastReportedTimestamp, setLastReportedTimeStamp] = useState();
    const [lastStatus, setLastStatus] = useState('--');

    useEffect(() => {
        lastReportedTimestamp && getData(lastReportedTimestamp);
    }, [lastReportedTimestamp]);

    useEffect(() => {
        getLastreported();
    }, []);

    const getData = () => {
        let filteredParams = {
            groupId: groupId,
            date: momentTz().tz('Europe/Berlin').format('YYYY-MM-DD'),
        };
        InstanceDataLogsService.Overview(
            filteredParams,
            () => startLoader('getInstanceOverview'),
            handleSuccess,
            handleError,
            () => stopLoader('getInstanceOverview')
        );
    };

    const handleSuccess = ({ data }) => {
        setData(data.data.powerData);
        setGroup(data.data.group);
    };

    const getLastreported = () => {
        if (groupId) {
            InstanceDataLogsService.LastReported(
                { groupId: groupId },
                () => startLoader('getOverviewGraphLastReported'),
                handleGetLastReportedSuccess,
                handleError,
                () => stopLoader('getOverviewGraphLastReported')
            );
        }
    };

    const handleGetLastReportedSuccess = ({ data }) => {
        const lastReported = data?.data?.lastReported;
        if (lastReported) {
            setLastStatus(momentTimeFormater(lastReported).format('YYYY-MM-DD'));
            setLastReportedTimeStamp(lastReported);
        }
    };

    const handleError = (error) => {
        console.error(error);
    };

    return (
        <div className={classes.TopGraph} style={{ flexGrow: 2 }}>
            <EChart
                series={data}
                title={licenseName ? `${Capitalize(licenseName)} (kW)` : ''}
                lastReported={lastStatus}
                xFormatter={timeOnly}
                yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))}
                lineStyle={{ color: primaryColor }}
                type="line"
                rightSideElement={<strong>{group?.name || ''}</strong>}
                zoomOnMouseWheel={false}
                yTooltipSuffix={['kW', 'kW']}
            />
        </div>
    );
};

export default InstanceCard;
